import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { StyledNotificationsScroll } from './NotificationsScroll.styles';

import notificationActions from '../../store/notification/actions';

class NotificationsScroll extends Component {
  componentDidMount() {
    const { getNotifications } = this.props;
    getNotifications();
  }

  componentWillUnmount() {
    const { viewNotifications } = this.props;
    viewNotifications();
  }

  render() {
    const { children } = this.props;
    return (
      <StyledNotificationsScroll>
        { children }
      </StyledNotificationsScroll>

    );
  }
}

NotificationsScroll.propTypes = {
  children: PropTypes.array,
  viewNotifications: PropTypes.func,
  getNotifications: PropTypes.func,
};

export default connect(() => {
  return {
  };
}, {
  getNotifications: notificationActions.getNotifications,
  viewNotifications: notificationActions.viewNotifications,
})(NotificationsScroll);
